import { lazy } from "react";
// Data Quality — validación de calidad de datos.
const DataQualityValidationPage = lazy(() => import("./DataQualityValidationPage"));
export const dataQualityRoutes = [
  { path: "/DataQualityValidationPage", element: <DataQualityValidationPage /> },
];

export { DataQualityValidationPage };
